import React, { useState, useEffect } from "react";

const Footer: React.FC = () => {
    return (<>
    <p className="small text-muted mt-4 text-center">
        If for any reason you have any questions or you believe any of the
        information below is incorrect, please contact us by calling the VSGA at
        (804) 378-2300.
      </p>
    </>)
}

export default Footer;